import {makeAutoObservable} from "mobx";
import {getDayPath, getDefaultContentUrl} from "./ContentStore";
import {displayErrorDialogPrompt} from "../common/util/errror/log.util";

const logPrefix  = "[OddStepSixStore]"
export default class OddStepSixStore {

    constructor(props) {
        this.contentRepository = props.contentRepository;
        this.contentStore = props.contentStore;
        this.dialogStore = props.dialogStore;
        this.commonStore = props.commonStore;

        this.content = null;
        this.originalContent = null;
        this.selectedContent = '';
        this.contentTapIndex = 0;
        this.audio = null;
        this.isProcessing = false;
        this.voiceTypeList = [];

        this.countryCodes = ["None", "England", "Australia"];

        makeAutoObservable(this);
    }

    openErrorDialog = (info) => {
        if (this?.dialogStore) {
            this.dialogStore.openErrorDialog(info)
        }
    };

    setContentTapIndex = (index) => {
        this.contentTapIndex = index;
    };

    setIsProcessing = (isProcessing) => {
        this.isProcessing = isProcessing;
    }

    isChangeContent = () => {
        return JSON.stringify(this.originalContent) !== JSON.stringify(this.content);
    }

    getSelectedCountryCode = () => {
        return this.countryCodes[this.contentTapIndex];
    }

    getSelectedAudio = () => {
        return this.content.audios.find(audio => audio.country === this.getSelectedCountryCode());
    }

    getVoiceType = (country) => {
        return this.voiceTypeList.find((vt) => vt.country === country).voiceType;
    }

    changeVoiceType = (voiceType) => {
        this.voiceTypeList.find((vt) => vt.country === this.getSelectedCountryCode()).voiceType = voiceType;
    }

    changeAudio = (audio) => {
        const selectedAudio = this.getSelectedAudio();
        selectedAudio.audio = audio;
        selectedAudio.voiceType = this.getVoiceType(selectedAudio.country);
    }

    playAudio = () => {
        const country = this.getSelectedCountryCode();
        if (this.audio && this.audio.country === country) {
            this.stopAudio();
        } else {
            if (this.audio) {
                this.stopAudio();
            }

            let audio;
            if (this.contentTapIndex === 0) {
                audio = this.content.mainAudio;
            } else {
                audio = this.content.audios.find((c) => c.country === country).audio;
            }

            const decodeAudio = atob(audio);
            const blob = new Blob([new Uint8Array(decodeAudio.length).map((_, i) => decodeAudio.charCodeAt(i))], { type: 'audio/mp3' });

            this.audio = new Audio();
            this.audio.country = country;
            this.audio.src = URL.createObjectURL(blob);
            this.audio.play();
        }
    }

    stopAudio = () => {
        if (this.audio) {
            this.audio.pause();
            this.audio = null;
        }
    }

    getChangeAudioList = () => {
        return this.content.audios.filter(a => {
            const originalAudio = this.originalContent.audios.find(oa => oa.country === a.country);
            return originalAudio && originalAudio.audio !== a.audio;
        });
    }


    * getOddStepSixContent(step, day, callback) {
        this.commonStore.setLoadingState();
        try {
            console.log(logPrefix, 'Start getOddStepSixContent.');
            const url = `${getDayPath(day)}/${getDefaultContentUrl(step, day)}/6`;
            const response = yield this.contentRepository.getContent(url);

            this.content = response.data;

            const audios = [];
            for (const country of this.countryCodes) {
                const audio = this.content.audios.find((a) => a.country === country);
                if (audio) {
                    this.voiceTypeList.push({country: audio.country, voiceType: audio.voiceType});
                    audios.push(audio);
                }
            }
            this.content.audios = audios;
            this.originalContent = JSON.parse(JSON.stringify(this.content));

            console.log(logPrefix, 'Finished getOddStepSixContent.');
            callback && callback(response.data);
        } catch (e) {
            console.log(logPrefix, 'Failed getOddStepSixContent.');
            this.openErrorDialog({
                titleText: '컨텐츠 불러오기 오류',
                text: displayErrorDialogPrompt(e, '컨텐츠를 불러오는 도중 에러가 발생했습니다.')
            });
        } finally {
            this.commonStore.initLoadingState();
        }
    }

    * modifyOddStepSixContent(step, day, callback) {
        this.commonStore.setLoadingState('데이터를 저장하는 중입니다.');
        try {
            console.log(logPrefix, 'Start modifyOddStepSixContent.');
            const url = `${getDayPath(day)}/${getDefaultContentUrl(step, day)}/6`;
            const response = yield this.contentRepository.putContent(url, this.getChangeAudioList());
            console.log(logPrefix, 'Finished modifyOddStepSixContent : ', response);
            callback && callback();
        } catch (e) {
            this.commonStore.initLoadingState();
            console.log(logPrefix, 'Failed modifyOddStepSixContent.');
            this.openErrorDialog({
                titleText: '컨텐츠 수정 오류',
                text: displayErrorDialogPrompt(e, '컨텐츠 수정 작업중 에러가 발생했습니다.')
            });
        }
    }

    isOddStepFourCompleted = (data) => {
        if (data.audios.length < 2) {
            return false;
        }

        for (const audio of data.audios) {
            if (audio.audio === null) {
                return false;
            }
        }

        return true;
    }
}

